import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getEventDetailsHash, getRemoteConfigs } from '../utils';
import ProjectRequestsStatusWidgetBody from './body';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    possibleMetricsCount: <string>,
    eventCategory: <string>,
    url: <string>,
    actionsData: {
      <actionUId>: {
        actionType: <actionType>,
        pinned: <true | false>,
        section: <header_action | footer_action>,
        data: <Hash for action component's data>,
        props: <Hash for action component's properties>
      }
    }
  }
}
*/

export const exportEventName = "projectRequestsStatusExportChart";

const ProjectRequestsStatus = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs(props);
  const filterKey = 'requestsSent';

  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, ProjectRequestsStatusWidgetBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'requests_sent_date_range') })
    };
  };

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName, eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default ProjectRequestsStatus;